document.addEventListener('DOMContentLoaded', () => {
      // Loop through each faq-container and open the first faq-item in each
      document.querySelectorAll('.faq-container').forEach(container => {
          const firstFaqItem = container.querySelector('.faq-item');
          if (firstFaqItem) {
              firstFaqItem.classList.add('active');
              firstFaqItem.querySelector('.faq-answer').style.display = 'block';
          }

          // Add click event listener for each faq-item inside this container
          container.querySelectorAll('.faq-item').forEach(item => {
              item.addEventListener('click', () => {
                  // Hide all other faq-answer elements within this container
                  container.querySelectorAll('.faq-answer').forEach(answer => {
                      if (answer !== item.querySelector('.faq-answer')) {
                          answer.style.display = 'none';
                          answer.parentElement.classList.remove('active');
                      }
                  });

                  // Toggle the clicked item
                  const answer = item.querySelector('.faq-answer');
                  if (answer.style.display === 'block') {
                      answer.style.display = 'none';
                      item.classList.remove('active');
                  } else {
                      answer.style.display = 'block';
                      item.classList.add('active');
                  }
              });
          });
      });
  });

/* ============================================================
   Baymard #5 — hover OPEN delay for hover-based drop-downs
   Added 2026-07-20 (CRO quick wins, June-approved).

   Why: Impact ships a CLOSE delay (DropdownDisclosure 250ms /
   MegaMenuDisclosure 500ms) but opens INSTANTLY on mouseover.
   Baymard's 2025 Homepage & Category Navigation benchmark
   (practice #5, 61% of sites fail) documents that instant-open
   menus cause the "flickering" failure — participants said they
   would leave the site. A 300–500ms intent delay fixes it.
   Ref: https://baymard.com/premium/blog/dropdown-menu-flickering-issue

   NB: patch the BASE class only. MegaMenuDisclosure extends
   DropdownDisclosure and does not override _detectHover, so this
   covers mega-menus AND plain dropdowns via inheritance. Patching
   both would double-wrap.

   Reversible: delete this block.
   ============================================================ */
(() => {
  const OPEN_DELAY_MS = 350;

  customElements.whenDefined('dropdown-disclosure').then(() => {
    const Disclosure = customElements.get('dropdown-disclosure');
    if (!Disclosure || Disclosure.prototype._catalystHoverDelayPatched) return;
    Disclosure.prototype._catalystHoverDelayPatched = true;

    const original = Disclosure.prototype._detectHover;

    Disclosure.prototype._detectHover = function (event) {
      // Only intervene in hover mode; click/touch keeps stock behaviour.
      if (this.trigger !== 'hover') return original.call(this, event);

      if (event.type === 'mouseover') {
        clearTimeout(this._hoverTimer);   // cancel any pending close
        if (this.open) return;            // already open — nothing to schedule
        clearTimeout(this._catalystOpenTimer);
        this._catalystOpenTimer = setTimeout(() => {
          this.open = true;
        }, OPEN_DELAY_MS);
      } else {
        // Left before the intent delay elapsed → never open (no flicker).
        clearTimeout(this._catalystOpenTimer);
        original.call(this, event);       // stock close delay
      }
    };
  });
})();
